import angular from 'angular';
import { TipoSolicitacaoEnum } from '../../../../../shared/enums/TipoSolicitacaoEnum';
import { ISolicitacaoBeneficio } from '../model/solicitacao.beneficio.model';
import { TipoBeneficios } from '../beneficios.enum';
import { IBeneficiario } from '../model/beneficios.model';

export class MeurhBeneficiosAlertaController {

    static $inject = [
        '$scope',
        '$state'
    ];

    public busy = false;
    public entity: ISolicitacaoBeneficio & IBeneficiario;

    public tipoSolicitacaoEnum = TipoSolicitacaoEnum;
    public mensagem: string;
    public rota: string;

    constructor(
        public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
    ) {}

    $onInit() {
        this.mensagem = this.setMensagem(this.entity);
        this.rota = this.setRota(this.entity.tiposolicitacao, this.entity.solicitacao);
    }

    setMensagem(entity: ISolicitacaoBeneficio & IBeneficiario) {
        const solicitacao = {
            [TipoSolicitacaoEnum.INCLUSAO_BENEFICIO]: 'solicitação',
            [TipoSolicitacaoEnum.CANCELAMENTO_BENEFICIO]: 'solicitação de cancelamento',
            [TipoSolicitacaoEnum.SUSPENSAO_BENEFICIO]: 'solicitação de suspensão',
            [TipoSolicitacaoEnum.PRORROGACAO_SUSPENSAO_BENEFICIO]: 'solicitação de prorrogação de suspensão',
            [TipoSolicitacaoEnum.TROCA_BENEFICIO]: 'solicitação de troca',
            [TipoSolicitacaoEnum.REATIVACAO_BENEFICIO]: 'solicitação de reativação',
        };
        const tipoSolicitacao = solicitacao[entity.tiposolicitacao];
        if (!tipoSolicitacao) {
            return '';
        }
        const tipoBeneficio = TipoBeneficios[entity.tipobeneficiointerno].nome.toLowerCase();
        const tipoBeneficiario = ('dependentetrabalhador' in entity.beneficiario) ? '(dependente)' : '(titular)';
        return `Existe uma ${tipoSolicitacao} de ${tipoBeneficio}
            em andamento para ${entity.beneficiario.nome} ${tipoBeneficiario}`;
    }

    setRota(tipoSolicitacao: TipoSolicitacaoEnum, solicitacao: string) {
        const rotas = {
            [TipoSolicitacaoEnum.INCLUSAO_BENEFICIO]: 'meurh_beneficios_show_inclusao',
            [TipoSolicitacaoEnum.CANCELAMENTO_BENEFICIO]: 'meurh_beneficios_show_cancelamento',
            [TipoSolicitacaoEnum.SUSPENSAO_BENEFICIO]: 'meurh_beneficios_show_suspensao',
            [TipoSolicitacaoEnum.PRORROGACAO_SUSPENSAO_BENEFICIO]: 'meurh_beneficios_show_prorrogacao',
            [TipoSolicitacaoEnum.TROCA_BENEFICIO]: 'meurh_beneficios_show_troca',
            [TipoSolicitacaoEnum.REATIVACAO_BENEFICIO]: 'meurh_beneficios_show_reativacao',
        };
        const rota = rotas[tipoSolicitacao];
        if (!rota) {
            return '';
        }
        return this.$state.href(rota, {
            solicitacao
        });
    }
}
